/** helper function to load next.js base path from environment variable */
export function getBasePath() {
    // support non public base path (set in next.config.js env)
    if (process.env.BASE_PATH) {
        return process.env.BASE_PATH;
    }
    // default
    return '';
}
export default getBasePath;
//# sourceMappingURL=getBasePath.js.map